export const kamon_addresses = {
  decoderAddress:"0xAa37fA6cEb855500E269513cA9e6E5F13B4D0D95",
  kamonAddress:"0x8a7376bb3BaEa9d697E078E3168189D49b9cCEeB"
}
